import React from 'react'
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import { Avatar, CircularProgress } from "@mui/material";

import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
} from "@mui/material";
import { IconButton } from "@mui/material";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { orange } from "@mui/material/colors";
import MDButton from 'components/MDButton';
import { addHobbies } from 'services/apis';
import Swal from "sweetalert2";
import { getHobbyData } from '../../redux/slices/hobbyDataSlice';

const HobbyDialog = ({ open, setOpen, HobbyId, setHobbyId }) => {
  const dispatch = useDispatch();
  const [imagePreview, setImagePreview] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [formData, setFormData] = useState({
    icon: "",
    hobbieName: "",
  });

  const handleClose = () => {
    console.log(formData);
    setFormData({
      icon: "",
      hobbieName: "",
    });
    setOpen(false);
    setImagePreview(null);
    setHobbyId(null)
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value,
    });
  };

  const handleFileInputEdit = (event) => {
    const file = event.target.files[0];
    setFormData({ ...formData, icon: file });
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setButtonLoading(true);

    try {
      // Convert formData object to FormData
      const newFormData = new FormData();
      newFormData.append("hobbiesCategoryId", HobbyId);
      // Append each key-value pair from formData to FormData
      for (const key in formData) {
        if (formData.hasOwnProperty(key)) {
          newFormData.append(key, formData[key]);
        }
      }

      // Send the FormData
      const response = await addHobbies(newFormData);
      console.log("response", response);

      if (response.success) {
        Swal.fire({
          icon: "success",
          title: "Hobby Added",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          dispatch(getHobbyData());
        });
      }
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Error Occurred",
      });
    } finally {
      setButtonLoading(false);
      handleClose();
    }
  };


  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Add Hobby
        <span
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            padding: "10px",
            cursor: "pointer",
          }}
        >
          <IconButton onClick={handleClose}>
            <CancelIcon sx={{ color: orange[500] }} />
          </IconButton>
        </span>
        <MDBox display="flex" justifyContent="center">
          <Avatar
            src={imagePreview}
            alt="icon-image"
            sx={{ height: "140px", width: "140px" }}
            shadow="sm"
          />
        </MDBox>

      </DialogTitle>
      <DialogContent style={{ overflowX: "hidden" }}>
        <form onSubmit={handleSubmit}>
          <label
            htmlFor="icon"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border: "1px solid #ccc",
              padding: "2px",
              marginTop: "11px",
              marginBottom: "4px",
              borderRadius: "5px",
            }}
          >
            <input
              type="file"
              id="icon"
              accept="image/*"
              required={!formData.icon}
              onChange={handleFileInputEdit}
              style={{ display: "none" }}
            />
            <Button component="span" color="primary" fullWidth>
              Add Icon
            </Button>
            <span
              style={{
                textAlign: "center",
                width: "100%",
                marginTop: "1px",
              }}
            >
              {formData.icon?.name}
            </span>
          </label>

          <TextField
            autoFocus
            margin="dense"
            id="hobbieName"
            name="hobbieName"
            label="Hobby Name "
            type="text"
            required
            fullWidth
            value={formData.hobbieName}
            onChange={handleChange}
          />

          <MDButton
            type="submit"
            variant="gradient"
            color="light"
            sx={{
              marginRight: "12px",
              marginTop: "10px",
            }}
            fullWidth
            disabled={Object.values(formData).some(
              (value) => !value)}
          >
            {buttonLoading ? (
              <MDBox display="flex" justifyContent="center" alignItems="center" width="100%">
                <CircularProgress sx={{ color: "#ffffff" }} size={24} />
              </MDBox>
            ) : (
              <MDTypography style={{ fontSize: "13.5px", fontWeight: "bold" }} color="white">
                Submit
              </MDTypography>
            )}
          </MDButton>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export default HobbyDialog